import moment from 'moment'

export default {
  props: ['weeks', 'actualDate', 'currency','showCarouselLowerFare','selectedSearchData','lookingForReturn', 'enabledDates'],
  name: 'carouselWeeks',
  data () {
    return {
      loading: true,
      moment: moment
    }
  },
  mounted () {
    setTimeout(() => {
      this.loading = false
    }, 100)
  },
  methods: {
    getDateI18n (date) {
      let momentDate = this.$moment(date.short_day, ['DD/MM/YYYY'])
      let day = momentDate.format('DD')
      let month = momentDate.format('MMM')
      month = month[0].toUpperCase() + month.substr(1)
      let year = momentDate.format('YYYY')
      return this.locale === 'es' ? `${day} ${month} ${year}` : `${month} ${day} ${year}`
    },
    sortedWeeks (dates) {
      return dates.slice().sort((a, b) => {
        const Adate = this.moment(Object.keys(a)[0], 'YYYY-MM-DD')
        const Bdate = this.moment(Object.keys(b)[0], 'YYYY-MM-DD')

        return Adate.diff(Bdate)
      })
    },
    isDatesEnabled (date) {
      let segment = 'ow'
      if (this.lookingForReturn) {
        segment = 'rt'
      }
      return this.enabledDates[segment] && !this.enabledDates[segment].includes(Object.keys(date)[0])
    },
    getI18nDatePart (date, format) {
      let momentDate = this.$moment(Object.keys(date)[0], 'YYYY-MM-DD')
      return momentDate.format(format)
    },
    getMonthI18n (date) {
      let momentDate = this.$moment(date.short_day, ['DD/MM/YYYY'])
      return momentDate.format('MMM')
    },
    changeDate (val) {
      this.$emit('changeDate', Object.keys(val)[0])
    },
    isAvailable (date) {
      return this.isValidDate(Object.keys(date)[0])
    },
    isValidDate (day) {
      return Boolean(this.moment(this.moment.now()).isBefore(day) || this.moment(day, 'YYYY-MM-DD').format('DD') === this.moment().format('DD'))
    },
    setPreviousWeek () {
      this.$emit('changeDate', this.getPreviousDayWeek)
    },
    setNextWeek () {
      this.$emit('changeDate', this.getNextDayWeek)
    }
  },
  computed: {
    getPreviousDayWeek () {
      const currentDate = this.moment().format('YYYY-MM-DD')
      const previousDayWeek = this.moment(this.getDaySelected, 'YYYY-MM-DD').subtract(7,'d').format('YYYY-MM-DD')
      if (
        this.moment(previousDayWeek).isBefore(currentDate) &&
        !this.getDatesOnly.includes(currentDate)
      ) return currentDate
      return previousDayWeek
    },
    getDatesOnly () {
      return this.sortedWeeks(this.weeks).map(x => { return Object.keys(x)[0] })
    },
    getDaySelected () {
      return this.getDatesOnly[3]
    },
    getNextDayWeek () {
      return this.moment(this.getDaySelected, 'YYYY-MM-DD').add(7,'d').format('YYYY-MM-DD')
    },
  }
}
